import './App.css';
import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Bioplastics from './components/Bioplastics';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';



export default function App() {


  return (
    <Router>
      <ScrollToTop />

      <Routes>
        <Route path='/' exact element={
          <>
            <Navbar />
            <Home />
            <Footer />
          </>
        } />
        <Route path='/about' exact element={
          <>
            <Navbar />
            <About />
            <Footer />
          </>
        } />
        <Route path='/bioplastics' exact element={
          <>
            <Navbar />
            <Bioplastics />
            <Footer />
          </>
        } />

      </Routes>
    </Router>
  );
}